<template>
  <div class="content">

    <div class="bereiche">
    <button class="button" @click="setSelectedComponent('Strategie')">STRATEGIE</button>
    <button class="button" @click="setSelectedComponent('Struktur')">STRUKTUR</button>
    <button class="button" @click="setSelectedComponent('Kultur')">KULTUR</button>
    <button class="button" @click="setSelectedComponent('IT')">IT</button>
    </div>
  
    <component :is="selectedComponent" 
    v-model:StrukturValue="struktur" v-model:StrukturValue2="struktur2" v-model:StrukturValue3="struktur3" 
    v-model:StrukturValue4="struktur4" v-model:StrukturValue5="struktur5" v-model:StrukturValue6="struktur6" 
    v-model:StrategieValue="strategie" v-model:StrategieValue2="strategie2" v-model:StrategieValue3="strategie3" 
    v-model:StrategieValue4="strategie4" v-model:StrategieValue5="strategie5" v-model:StrategieValue6="strategie6" 
    v-model:KulturValue="kultur" v-model:KulturValue2="kultur2" v-model:KulturValue3="kultur3" 
    v-model:KulturValue4="kultur4" v-model:KulturValue5="kultur5" v-model:KulturValue6="kultur6" v-model:KulturValue7="kultur7" v-model:KulturValue8="kultur8" v-model:KulturValue9="kultur9" v-model:KulturValue10="kultur10"
    v-model:ITValue="it" v-model:ITValue2="it2" v-model:ITValue3="it3" 
    v-model:ITValue4="it4" v-model:ITValue5="it5" v-model:ITValue6="it6" 

    @saved="setSelectedComponent('Ergebnis')">
    </component>

  </div>

</template>

<script>
  import Strategie from "./components/Strategie.vue";
  import Ergebnis from "./components/Ergebnis.vue";
  import Struktur from "./components/Struktur.vue";
  import Kultur from "./components/Kultur.vue";
  import IT from "./components/IT.vue";
  import Start from "./components/Start.vue";

  export default {
    components: {
      Ergebnis,
      Strategie,
      Struktur,
      Kultur,
      IT,
      Start,
    },
    data() {
      return {
        selectedComponent: "Start",
        StrategieValue: null,
        StrategieValue2: null,
        StrategieValue3: null,
        StrategieValue4: null,
        StrategieValue5: null,
        StrategieValue6: null,
        ITValue: null,
        ITValue2: null,
        ITValue3: null,
        ITValue4: null,
        ITValue5: null,
        ITValue6: null,
        StrukturValue: null,
        StrukturValue2: null,
        StrukturValue3: null,
        StrukturValue4: null,
        StrukturValue5: null,
        StrukturValue6: null,
        KulturValue: null,
        KulturValue2: null,
        KulturValue3: null,
        KulturValue4: null,
        KulturValue5: null,
        KulturValue6: null,
        KulturValue7: null,
        KulturValue8: null,
        KulturValue9: null,
        KulturValue10: null,

      };
    },
    methods: {
      setSelectedComponent(cmp) {
        this.selectedComponent = cmp;
      },
    }
  };
</script>



<style>
.content {
  margin: 0 auto;
  padding: 0;
  background-color: #fff;
}

.bereiche {
  height: 70px;
  width: 600px;
  margin: 20px auto;
  justify-content: center;

}


.button {
  font-size: 15px;
  height: 70px;
  width: 130px;
  background-color: #0A2342;
  margin: 0px 10px;
  border-color: #00FFFF;
  color:#FFFFFF; 
  justify-content: center;
  font-family: 'Poppins', 'Arial Black', Gadget, sans;
}

.button:active
{
  background-color: #00FFFF;
       
}
.button:focus
{
  background-color: #00FFFF;
       
}

</style>